import { render, staticRenderFns } from "./feedquestion.vue?vue&type=template&id=0053c197&lang=true&"
import script from "./feedquestion.vue?vue&type=script&lang=js&"
export * from "./feedquestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports